import Image from 'next/image';

import TrustpilotRating from '@common/Icons/TrustpilotRating';
import TrustpilotSNBlue from '@common/Icons/TrustpilotSNBlue';
import { BodySmall } from '@common/body';
import { H6 } from '@common/headline';
import PenSmall from '@common/Icons/PenSmall';

import ellipse from '@public/img/medically-supported/ellipse-yellow.png';
import Checkbox from '@public/img/medically-supported/checkbox.png';

type Props = {
  medication: 'Wegovy' | 'Mounjaro';
};

export const TrustpilotBox = ({ medication }: Props): JSX.Element => (
  <div className="mt-[8px] flex w-full justify-between rounded-2xl border-2 border-mono-white bg-mono-white/80 p-3 lg:mt-0 lg:w-fit lg:gap-x-[16px]">
    <div className="mr-3 flex flex-col justify-center">
      <div className="flex items-center gap-x-[4px] lg:gap-x-[10px]">
        <Image alt="In Stock" height={21} src={Checkbox} width={21} />
        <H6>{medication} in stock</H6>
      </div>
      <div className="mt-3 flex flex-row items-center gap-x-[4px] lg:gap-x-[10px]">
        <div className="relative">
          <Image src={ellipse} height={21} width={21} alt="Ellipse" />
          <div className="absolute left-[-2px] top-[-1px]">
            <PenSmall />
          </div>
        </div>
        <H6>Medication guarantee</H6>
      </div>
    </div>
    <a
      href="https://uk.trustpilot.com/review/secondnature.io"
      id="aggregateRating"
      rel="noreferrer"
      target="_blank"
    >
      <TrustpilotSNBlue width={70} className="m-0" />
      <div className="mt-[-8px]">
        <TrustpilotRating width={96} />
      </div>
      <div className="text-left">
        <BodySmall>7,458 reviews</BodySmall>
      </div>
    </a>
  </div>
);
